@if (error(); as message) {
  <div class="mt-20">
    <ui-api-error [message]="message" [showBack]="true" (back)="goBack()" />
  </div>
} @else {
  <div class="flex flex-col items-center justify-center gap-6 min-h-screen">
    <mat-spinner [diameter]="56" />
    <p class="text-cp-gray-700">Tarifdetails werden geladen …</p>
  </div>
}
